import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import {PageView, initGA} from '../../features/Tracking';
import { withTranslation } from 'react-i18next';


class Terms extends React.Component {
    componentDidMount() {
        initGA();
        PageView();

    }
    render() {
        const { t } = this.props;

        return(
            <div className="App MemberTerms">
                <Header  hide='true' hideSearch={true} />
                <main>
                    <h1>{t('memberTerms.title')}</h1>
                    <p><u>{t('memberTerms.sections.general.heading')}</u></p>
                    <p>{t('memberTerms.sections.general.intro')}</p>
                    <p>{t('memberTerms.sections.general.terms')}</p>
                    <p>{t('memberTerms.sections.general.responsibility')}</p>
                    <p>{t('memberTerms.sections.general.language')}</p>

                    <u>{t('memberTerms.sections.eligibility.heading')}</u>
                    <p>{t('memberTerms.sections.eligibility.content')}</p>

                    <u>{t('memberTerms.sections.benefitChanges.heading')}</u>
                    <p>{t('memberTerms.sections.benefitChanges.content')}</p>


                    <u>{t('memberTerms.sections.notifications.heading')}</u>
                    <p>{t('memberTerms.sections.notifications.content')}</p>

                    <u>{t('memberTerms.sections.security.heading')}</u>
                    <p>{t('memberTerms.sections.security.content')}</p>

                    <u>{t('memberTerms.sections.compliance.heading')}</u>
                    <p>{t('memberTerms.sections.compliance.content')}</p>

                    <u>{t('memberTerms.sections.violation.heading')}</u>
                    <p>{t('memberTerms.sections.violation.content')}</p>

                    <u>{t('memberTerms.sections.termination.heading')}</u>
                    <p>{t('memberTerms.sections.termination.content')}</p>

                    <u>{t('memberTerms.sections.jurisdiction.heading')}</u>
                    <p>{t('memberTerms.sections.jurisdiction.content')}</p>

                    <u>{t('memberTerms.sections.contact.heading')}</u>
                    <p>{t('memberTerms.sections.contact.content')}
                    <img src="/images/contact_us_mail.jpg"  alt="email"></img>
                    </p>


                </main>
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Terms);
